import en from './locales/en.json' with { type: 'json' };
import si from './locales/si.json' with { type: 'json' };
import ta from './locales/ta.json' with { type: 'json' };
/** Supported_Locale values (Req 22.1). */
export const SUPPORTED_LOCALES = ['en', 'si', 'ta'];
export const DEFAULT_LOCALE = 'en';
/** BCP 47 tags used for Intl formatting per Supported_Locale (Req 22.4). */
export const INTL_LOCALES = {
    en: 'en-LK',
    si: 'si-LK',
    ta: 'ta-LK',
};
/**
 * Locale resources. Typing `si` and `ta` as `Messages` makes a key that
 * exists in `en` but is missing elsewhere a compile error.
 */
export const resources = {
    en,
    si: si,
    ta: ta,
};
export function isLocale(value) {
    return typeof value === 'string' && SUPPORTED_LOCALES.includes(value);
}
/**
 * Resolve a loose locale hint (`si`, `si-LK`, `ta_LK`, `EN`) to a Supported_Locale,
 * falling back to `fallback` when unsupported or missing.
 */
export function resolveLocale(value, fallback = DEFAULT_LOCALE) {
    if (!value)
        return fallback;
    const primary = value.trim().toLowerCase().split(/[-_]/)[0];
    return isLocale(primary) ? primary : fallback;
}
export function intlLocale(locale) {
    return INTL_LOCALES[locale];
}
/** Look up a raw (unformatted) ICU message by dot path, or `undefined` if absent. */
export function getMessage(locale, key) {
    let node = resources[locale];
    for (const part of key.split('.')) {
        if (node === null || typeof node !== 'object')
            return undefined;
        node = node[part];
    }
    return typeof node === 'string' ? node : undefined;
}
//# sourceMappingURL=locales.js.map